import { Sidebar } from './Sidebar'
import WebModel from '../models/WebModel'
import { DEFAULT_REFRESH_INTERVAL } from '../constants'

export class SidebarBtf extends Sidebar {
  slotName = 'sticky_sidebar'

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)
    this.adUnitId = 'sidebar_btf'
    this.refreshTime = DEFAULT_REFRESH_INTERVAL
    this.lazy = true
  }
}
